<div class="main-content">
  <div class="nav-area"><app-nav-footer></app-nav-footer></div>
  <div class="main-content-input">
    <app-header></app-header>
        <div class="contractDetails">
            <h1 class="DieterHeading1">Imprint</h1>
            <h2 class="HeadingLeft"><span>Provider</span></h2>
            <p class="Body">Irina Gorges</p>
            <p class="Body"><span class="multiline">Bachstr. 37
                37574 Einbeck</span>
            </p>
            <h2 class="HeadingLeft"><span>Contact us</span></h2>
            <p class="Body">E-Mail: irinagorges&#64;live.de</p>
            <p class="Body">Phone: 017064665231</p>
            <h2 class="HeadingLeft"><span>Data protection notice</span></h2>
            <p class="Body">You can find our Privacy Policy at: <a href="https://join.irina-gorges.de/#/privacy-sign-in" target="_blank">https://join.irina-gorges.de/#/privacy-sign-in</a></p>
            <h2 class="HeadingLeft"><span>Copyright notice</span></h2>
            <p class="Body">The texts, images, photos, videos or graphics available on our website are generally subject to copyright protection. Any unauthorized use (especially copying, editing or distribution) of this copyright-protected content is therefore prohibited. If you intend to use this content or parts thereof, please contact us in advance using the details above. If we are not the owner of the required copyrighted rights of use ourselves, we will endeavor to arrange contact with the entitled party.</p>
            <p class="DieterSmall"><span><i>Created with the kind support of </i></span>
                <a href="https://www.dieter-datenschutz.de/">
                    <span><i>Dieter does data protection</i></span>
                </a>
            </p>
        </div>
  </div>
</div>
<app-nav-footer-mobile></app-nav-footer-mobile>

